import React, { ReactElement } from 'react';
import Store from 'mockStores/components/stores/Store';

function VccStore(): ReactElement {
  return (
    <div>
      <Store
        title="Honey Checkout Mock Store (VCC)"
        description="The element with ID paymentDetails should indicate that this store should trigger VCC."
      />
      <div id="paymentDetails">paymentDetails element is present</div>
    </div>
  );
}

export default VccStore;
